import {Link} from "react-router-dom";

export default function ERP() {
  return (
    <div className="erp">

      {/* HERO */}
      <section className="erp-hero">

        <h2>ERP Solutions</h2>

        <p>
          We provide customized ERP software solutions for schools,
          institutes and businesses to manage operations efficiently
          through a single integrated platform.
        </p>

      </section>


      {/* ERP MODULES */}
      <section className="erp-modules">

        <h3>ERP Modules</h3>

        <div className="erp-module-grid">

          <div className="erp-module-card">
            <h4>Student Management</h4>
            <p>Manage student records, attendance and academic data.</p>
          </div>

          <div className="erp-module-card">
            <h4>Fee Management</h4>
            <p>Track fee payments, receipts and financial reports.</p>
          </div>

          <div className="erp-module-card">
            <h4>Staff Management</h4>
            <p>Manage staff details, roles and payroll information.</p>
          </div>

          <div className="erp-module-card">
            <h4>Reports & Analytics</h4>
            <p>Generate insights and reports for better decision making.</p>
          </div>

        </div>

      </section>


      {/* FEATURES */}
      <section className="erp-features">

        <h3>Key Features</h3>

        <div className="erp-feature-grid">

          <div className="erp-feature-card">
            <h4>Cloud Based System</h4>
            <p>Access your ERP system anytime and from anywhere.</p>
          </div>

          <div className="erp-feature-card">
            <h4>Secure Data</h4>
            <p>High-level security and data protection mechanisms.</p>
          </div>

          <div className="erp-feature-card">
            <h4>User Friendly</h4>
            <p>Simple interface designed for ease of use.</p>
          </div>

          <div className="erp-feature-card">
            <h4>Customizable</h4>
            <p>ERP modules customized according to your requirements.</p>
          </div>

        </div>

      </section>


      {/* IMPLEMENTATION PROCESS */}
      <section className="erp-process">

        <h3>Implementation Process</h3>

        <div className="erp-process-grid">

          <div className="process-step">
            <h4>Requirement Analysis</h4>
            <p>Understanding your organization's needs.</p>
          </div>

          <div className="process-step">
            <h4>System Design</h4>
            <p>Designing ERP structure based on workflow.</p>
          </div>

          <div className="process-step">
            <h4>Development</h4>
            <p>Building customized ERP modules.</p>
          </div>

          <div className="process-step">
            <h4>Deployment</h4>
            <p>Launching ERP system with training support.</p>
          </div>

        </div>

      </section>


      {/* CTA */}
      <section className="erp-cta">

        <h3>Transform Your Organization with ERP</h3>

        <p>
          Contact us today to get a customized ERP solution for your
          organization.
        </p>

        <Link className="app-cta-link" to="/contact">Request Demo</Link>

      </section>

    </div>
  );
}
